var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.ScheduleType==1)?_c('brandNewIndex'):(_vm.ScheduleType==2)?_c('newindex'):(_vm.ScheduleType==3)?_c('gridNewIndex'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }